import { FormStateModel } from 'src/app/form.state.model';
import { ServiceAreaModel } from 'src/app/models/service-area.model';

import { CountriesModel } from '../../../models/countries.model';
import { CustomerModel } from '../../../models/customer.model';
import { DelivererModel } from '../../../models/deliverer.model';
import { DiscountModel } from '../../../models/discount.model';
import { MembersModel, MemberRoles } from '../../../models/members.model';
import { StatesAndCitiesModel } from '../../../models/states.model';

export class MembersStateModel {
    // TODO should not be any
    addForm = new FormStateModel<any>();
    addCustomerForm = new FormStateModel();
    addDelivererForm = new FormStateModel();
    addDiscountForm = new FormStateModel<any>();
    discountList: DiscountModel[] = [];
    customersList: CustomerModel[] = [];
    delivererslist: DelivererModel[];
    membersList: MembersModel[];
    memberRoles: MemberRoles[];
    selectedMember: MembersModel;
    countriesList: CountriesModel[];
    statesList: StatesAndCitiesModel[];
    citiesList: StatesAndCitiesModel[];
    serviceAreasList: ServiceAreaModel[];
    currentUser: any;
}
